import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eEstadoPasstAcitividadEjecucion, eEstadosEdicionPasstAcitividad, eTypeResult, ParametrosMaestro, Roles } from 'src/app/models/common/enumModel';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';
import { IFilterPasstModel } from 'src/app/models/interfaces/passt/IFilterPasstModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterPasstModel } from 'src/app/models/passt/FilterPasstModel';
import { PasstCompletarModel } from 'src/app/models/passt/PasstCompletarModel';
import { PasstDetalleCompletarModel } from 'src/app/models/passt/PasstDetalleCompletarModel';
import { ResumenPasstModel } from 'src/app/models/passt/ResumenPasstModel';
import { DetalleSeguimientoPasstModel, SeguimientoPasstModel } from 'src/app/models/passt/SeguimientoPasstModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { PasstService } from 'src/app/services/passt/passt.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { LogDialogComponent } from '../../shared/log-dialog/log-dialog.component';
import { PasstActividadCancelarDialogComponent } from '../passt-actividad-cancelar-dialog/passt-actividad-cancelar-dialog.component';
import { PasstActividadEliminarDialogComponent } from '../passt-actividad-eliminar-dialog/passt-actividad-eliminar-dialog.component';
import { PasstActividadReprogramarDialogComponent } from '../passt-actividad-reprogramar-dialog/passt-actividad-reprogramar-dialog.component';
import { PasstActividadSolicitarEdicionDialogComponent } from '../passt-actividad-solicitar-edicion-dialog/passt-actividad-solicitar-edicion-dialog.component';
import { PasstSolicitarProgramacionEdicionDialogComponent } from '../passt-solicitar-programacion-edicion-dialog/passt-solicitar-programacion-edicion-dialog.component';
import * as fileSaver from 'file-saver';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  data?: Array<DetalleSeguimientoPasstModel>
}

@Component({
  templateUrl: './passt-seguimiento-listar.component.html',
  styleUrls: ['./passt-seguimiento-listar.component.css']
})
export class PasstSeguimientoListarComponent implements OnInit {
  esAdminSSO:boolean = false;
  model: IFilterPasstModel;
  listaResumen: ResumenPasstModel[] = new Array<ResumenPasstModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  
  listaEstadosProgramacion: ParametroModel[] = new Array<ParametroModel>();
  listaAnios: Number[];
  resultsLength = 0;
  idPasst:number = 0;
  comentarioPasst:string='';
  idEstadoEdicion:number = 0;
  passtEditable: boolean=false;
  puedeSolicitar: boolean=false;
  mesPasstEditable:number=0;
  currentPage = 0;
  currentCalendar: CalendarioSsoModel;

  private _transformer = (node: SeguimientoPasstModel, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      data: node.data,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener<SeguimientoPasstModel,ExampleFlatNode>(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(public dialog: MatDialog,
    private storage: StorageService,
    private calendarioService: CalendarioSsoService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private parametroService: ParametroService,
    private passtService: PasstService,
    private sedeService: SedeService,) {
    this.model = new FilterPasstModel();
    this.listaAnios = new Array<number>();
    this.currentCalendar = new CalendarioSsoModel();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.model.idCompania = usuario.companiaDefault.idCompania;
  }
  

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  
  displayedColumnsResumen: string[] = ['resumen','enero', 'febrero','marzo', 'abril', 'mayo',  'junio', 'julio', 'agosto', 'setiembre', 'octubre', 'noviembre', 'diciembre', 'total'];
  displayedColumnsActividades: string[] = ['actividad','enero', 'febrero','marzo', 'abril', 'mayo',  'junio', 'julio', 'agosto', 'setiembre', 'octubre', 'noviembre', 'diciembre', 'acciones'];
  
  ngOnInit(): void {
    let usuario = this.storage.getCurrentUser();
    if(usuario.selectedRoles){
      this.esAdminSSO = usuario.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO)? true : false;
    }
    this.companiaChanged();
    this.calendarioService.getAnios()
    .subscribe((data: number[]) => {
      this.listaAnios = data;
    });
      this.calendarioService.getCurrent(this.model.idCompania)
      .subscribe((data: CalendarioSsoModel) => {
        this.currentCalendar = data;
        if(data.mes>0){
          this.model.anio = data.anio;
        }
      });
    
      this.parametroService
      .getDetalles(ParametrosMaestro.ESTADOS_PASST_ACTIVIDAD_EJECUCION)
      .subscribe((p) => {
        this.listaEstados = p.items;
      });
      this.parametroService
      .getDetalles(ParametrosMaestro.ESTADOS_PASST_ACTIVIDAD_PROGRAMADA)
      .subscribe((p) => {
        this.listaEstadosProgramacion = p.items;
      });
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.idSede = 0;
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
        if(data.length>0){
          this.model.idSede = data[0].idSede;
        }
      });
  }

  search() {
    if(this.model.idSede ==0){
      
      return;
    }
    this.model.page = 1;
    this.model.pageSize = 30;
    this.passtService
      .getResumen(this.model)
      .subscribe((data: ResumenPasstModel[]) => {
        this.listaResumen = data
        if(data.length>0){
          this.passtEditable = data[0].editable;
          this.mesPasstEditable = data[0].mesEditable;
          this.idPasst = data[0].idPasst;
          this.idEstadoEdicion = data[0].idEstadoEdicion;
          this.puedeSolicitar = data[0].puedeSolicitar;
        }
        else{
          this.idPasst = 0;
          this.idEstadoEdicion = 0;
          this.alertDialogService.open(`No se ha realizado la programación para ${this.model.anio}, en la sede seleccionada.`)
        }
      });

    this.passtService
      .getSeguimiento(this.model)
      .subscribe((data: SeguimientoPasstModel[]) => {
        this.dataSourceTree.data = data;
        this.treeControl.expandAll();
      });
  }

  EsValido() {
    let message="Complete las siguientes actividades\n";
    let esValido=true;
    this.dataSourceTree.data.forEach(function (grupo1) {
      if(grupo1.children){
        grupo1.children.forEach(function (grupo2) {
          if(grupo2.children){
            grupo2.children.forEach(function (actividad) {
              if(actividad.data){
                actividad.data.filter((p) =>p.eneroProgramado === 'P' && !p.idEstadoEnero && p.eneroEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.febreroProgramado === 'P' && !p.idEstadoFebrero && p.febreroEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.marzoProgramado === 'P' && !p.idEstadoMarzo && p.marzoEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.abrilProgramado === 'P' && !p.idEstadoAbril && p.abrilEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.mayoProgramado === 'P' && !p.idEstadoMayo && p.mayoEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.junioProgramado === 'P' && !p.idEstadoJunio && p.junioEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.julioProgramado === 'P' && !p.idEstadoJulio && p.julioEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.agostoProgramado === 'P' && !p.idEstadoAgosto && p.agostoEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.setiembreProgramado === 'P' && !p.idEstadoSetiembre && p.setiembreEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.octubreProgramado === 'P' && !p.idEstadoOctubre && p.octubreEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.noviembreProgramado === 'P' && !p.idEstadoNoviembre && p.noviembreEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                actividad.data.filter((p) =>p.diciembreProgramado === 'P' && !p.idEstadoDiciembre && p.diciembreEditable).forEach(function (item) {
                  message += `${item.actividad}\n`;
                  esValido = false;
                });
                
              }
            });
          }
        });
      }
    }); 
    if(!esValido)
      this.alertDialogService.open(message);
    return esValido;
  }

  registrar(){
    if(this.esAdminSSO || this.passtEditable || this.EsValido()){
      const esAdmin = this.esAdminSSO;
      const editandoPrograma = this.passtEditable;
      const mesEditandoPrograma = this.mesPasstEditable;
      let detalle: Array<PasstDetalleCompletarModel> = new Array<PasstDetalleCompletarModel>();
      this.dataSourceTree.data.forEach(function (grupo1) {
        if(grupo1.children){
          grupo1.children.forEach(function (grupo2) {
            if(grupo2.children){
              grupo2.children.forEach(function (actividad) {
                if(actividad.data){
                  actividad.data.filter((p) =>(p.eneroEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 1))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 1;
                    programa.idEstadoEjecucion = item.idEstadoEnero;
                    programa.mesReprogramado = item.mesReprogramadoEnero;
                    programa.codigoEstadoProgramado = item.eneroProgramado;
                    programa.comentarios = item.comentarioEnero;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.febreroEditable|| esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 2))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 2;
                    programa.idEstadoEjecucion = item.idEstadoFebrero;
                    programa.mesReprogramado = item.mesReprogramadoFebrero;
                    programa.codigoEstadoProgramado = item.febreroProgramado;
                    programa.comentarios = item.comentarioFebrero;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.marzoEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 3))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 3;
                    programa.idEstadoEjecucion = item.idEstadoMarzo;
                    programa.mesReprogramado = item.mesReprogramadoMarzo;
                    programa.codigoEstadoProgramado = item.marzoProgramado;
                    programa.comentarios = item.comentarioMarzo;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.abrilEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 4))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 4;
                    programa.idEstadoEjecucion = item.idEstadoAbril;
                    programa.mesReprogramado = item.mesReprogramadoAbril;
                    programa.codigoEstadoProgramado = item.abrilProgramado;
                    programa.comentarios = item.comentarioAbril;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.mayoEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 5))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 5;
                    programa.idEstadoEjecucion = item.idEstadoMayo;
                    programa.mesReprogramado = item.mesReprogramadoMayo;
                    programa.codigoEstadoProgramado = item.mayoProgramado;
                    programa.comentarios = item.comentarioMayo;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.junioEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 6))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 6;
                    programa.idEstadoEjecucion = item.idEstadoJunio;
                    programa.mesReprogramado = item.mesReprogramadoJunio;
                    programa.codigoEstadoProgramado = item.junioProgramado;
                    programa.comentarios = item.comentarioJunio;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.julioEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 7))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 7;
                    programa.idEstadoEjecucion = item.idEstadoJulio;
                    programa.mesReprogramado = item.mesReprogramadoJulio;
                    programa.codigoEstadoProgramado = item.julioProgramado;
                    programa.comentarios = item.comentarioJulio;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.agostoEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 8))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 8;
                    programa.idEstadoEjecucion = item.idEstadoAgosto;
                    programa.mesReprogramado = item.mesReprogramadoAgosto;
                    programa.codigoEstadoProgramado = item.agostoProgramado;
                    programa.comentarios = item.comentarioAgosto;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.setiembreEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 9))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 9;
                    programa.idEstadoEjecucion = item.idEstadoSetiembre;
                    programa.mesReprogramado = item.mesReprogramadoSetiembre;
                    programa.codigoEstadoProgramado = item.setiembreProgramado;
                    programa.comentarios = item.comentarioSetiembre;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.octubreEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 10))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 10;
                    programa.idEstadoEjecucion = item.idEstadoOctubre;
                    programa.mesReprogramado = item.mesReprogramadoOctubre;
                    programa.codigoEstadoProgramado = item.octubreProgramado;
                    programa.comentarios = item.comentarioOctubre;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.noviembreEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 11))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 11;
                    programa.idEstadoEjecucion = item.idEstadoNoviembre;
                    programa.mesReprogramado = item.mesReprogramadoNoviembre;
                    programa.codigoEstadoProgramado = item.noviembreProgramado;
                    programa.comentarios = item.comentarioNoviembre;
                    detalle.push(programa);
                  });
                  actividad.data.filter((p) =>(p.diciembreEditable || esAdmin || p.editable || (editandoPrograma && mesEditandoPrograma <= 12))).forEach(function (item) {
                    let programa = new PasstDetalleCompletarModel();
                    programa.idPasstActividad=item.idPasstActividad;
                    programa.mes = 12;
                    programa.idEstadoEjecucion = item.idEstadoDiciembre;
                    programa.mesReprogramado = item.mesReprogramadoDiciembre;
                    programa.codigoEstadoProgramado = item.diciembreProgramado;
                    programa.comentarios = item.comentarioDiciembre;
                    detalle.push(programa);
                  });
                  
                }
              });
            }
          });
        }
      }); 
      let completarModel = new PasstCompletarModel();
      completarModel.idPasst = this.idPasst;
      completarModel.comentarios = this.comentarioPasst;
      completarModel.actividades=detalle;
      this.confirmDialogService.open('¿Está seguro que desea enviar su información PASST?'); //options
          this.confirmDialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {  
              this.passtService.completar(completarModel).subscribe((result: ActionResultModel) => {
                console.log(result);
                if(result.type!=eTypeResult.SUCCESS){
                  this.alertDialogService.open(result.message);
                }else{
                  if(this.esAdminSSO)
                    this.alertDialogService.open(`Su información PASST fue registrada correctamente.`);
                  else
                    this.alertDialogService.open(`Su información PASST del mes de ${this.currentCalendar.nombreMes} fue registrada correctamente.`);
                  this.search();
                }
              },error => {
                //console.log('oops', error)
                this.alertDialogService.open(`Se produjo un error al registrar su información, por favor contactar con el administrador. Detalle: ${error.title}.`)
              });
            }
          });
    }
  }

  stateChanged(selectedValue: any, item: DetalleSeguimientoPasstModel, nroMes: number){
      if(selectedValue.value == eEstadoPasstAcitividadEjecucion.Reprogramado){
        const dialogRef = this.dialog.open(PasstActividadReprogramarDialogComponent, {
          width: '700px',
          // data: { name: this.name, animal: this.animal}
          data: item
        });    
    
        dialogRef.afterClosed().subscribe(result => {
          if(!result || !result.mesReprogramado){
            if(nroMes==1){
              item.idEstadoEnero=undefined;
              item.mesReprogramadoEnero=undefined;
              item.comentarioEnero=undefined;
            }
            if(nroMes==2){
              item.idEstadoFebrero=undefined;
              item.mesReprogramadoFebrero=undefined;
              item.comentarioFebrero=undefined;
            }
            if(nroMes==3){
              item.idEstadoMarzo=undefined;
              item.mesReprogramadoMarzo=undefined;
              item.comentarioMarzo=undefined;
            }
            if(nroMes==4){
              item.idEstadoAbril=undefined;
              item.mesReprogramadoAbril=undefined;
              item.comentarioAbril=undefined;
            }
            if(nroMes==5){
              item.idEstadoMayo=undefined;
              item.mesReprogramadoMayo=undefined;
              item.comentarioMayo=undefined;
            }
            if(nroMes==6){
              item.idEstadoJunio=undefined;
              item.mesReprogramadoJunio=undefined;
              item.comentarioJunio=undefined;
            }
            if(nroMes==7){
              item.idEstadoJulio=undefined;
              item.mesReprogramadoJulio=undefined;
              item.comentarioJulio=undefined;
            }
            if(nroMes==8){
              item.idEstadoAgosto=undefined;
              item.mesReprogramadoAgosto=undefined;
              item.comentarioAgosto=undefined;
            }
            if(nroMes==9){
              item.idEstadoSetiembre=undefined;
              item.mesReprogramadoSetiembre=undefined;
              item.comentarioSetiembre=undefined;
            }
            if(nroMes==10){
              item.idEstadoOctubre=undefined;
              item.mesReprogramadoOctubre=undefined;
              item.comentarioOctubre=undefined;
            }
            if(nroMes==11){
              item.idEstadoNoviembre=undefined;
              item.mesReprogramadoNoviembre=undefined;
              item.comentarioNoviembre=undefined;
            }
            if(nroMes==12){
              item.idEstadoDiciembre=undefined;
              item.mesReprogramadoDiciembre=undefined;
              item.comentarioDiciembre=undefined;
            }
          }
          else{
            if(nroMes==1){
              item.mesReprogramadoEnero=item.mesReprogramado;
              item.comentarioEnero=item.comentarios;
            }
            if(nroMes==2){
              item.mesReprogramadoFebrero=item.mesReprogramado;
              item.comentarioFebrero=item.comentarios;
            }
            if(nroMes==3){
              item.mesReprogramadoMarzo=item.mesReprogramado;
              item.comentarioMarzo=item.comentarios;
            }
            if(nroMes==4){
              item.mesReprogramadoAbril=item.mesReprogramado;
              item.comentarioAbril=item.comentarios;
            }
            if(nroMes==5){
              item.mesReprogramadoMayo=item.mesReprogramado;
              item.comentarioMayo=item.comentarios;
            }
            if(nroMes==6){
              item.mesReprogramadoJunio=item.mesReprogramado;
              item.comentarioJunio=item.comentarios;
            }
            if(nroMes==7){
              item.mesReprogramadoJulio=item.mesReprogramado;
              item.comentarioJulio=item.comentarios;
            }
            if(nroMes==8){
              item.mesReprogramadoAgosto=item.mesReprogramado;
              item.comentarioAgosto=item.comentarios;
            }
            if(nroMes==9){
              item.mesReprogramadoSetiembre=item.mesReprogramado;
              item.comentarioSetiembre=item.comentarios;
            }
            if(nroMes==10){
              item.mesReprogramadoOctubre=item.mesReprogramado;
              item.comentarioOctubre=item.comentarios;
            }
            if(nroMes==11){
              item.mesReprogramadoNoviembre=item.mesReprogramado;
              item.comentarioNoviembre=item.comentarios;
            }
            if(nroMes==12){
              item.mesReprogramadoDiciembre=item.mesReprogramado;
              item.comentarioDiciembre=item.comentarios;
            }
          }
        });
      }
      else if(selectedValue.value == eEstadoPasstAcitividadEjecucion.Cancelado){
        const dialogRef = this.dialog.open(PasstActividadCancelarDialogComponent, {
          width: '700px',
          // data: { name: this.name, animal: this.animal}
          data: item
        });    
    
        dialogRef.afterClosed().subscribe(result => {
          if(!result || !result.comentarios){
            if(nroMes==1){
              item.idEstadoEnero=undefined;
              item.mesReprogramadoEnero=undefined;
              item.comentarioEnero=undefined;
            }
            if(nroMes==2){
              item.idEstadoFebrero=undefined;
              item.mesReprogramadoFebrero=undefined;
              item.comentarioFebrero=undefined;
            }
            if(nroMes==3){
              item.idEstadoMarzo=undefined;
              item.mesReprogramadoMarzo=undefined;
              item.comentarioMarzo=undefined;
            }
            if(nroMes==4){
              item.idEstadoAbril=undefined;
              item.mesReprogramadoAbril=undefined;
              item.comentarioAbril=undefined;
            }
            if(nroMes==5){
              item.idEstadoMayo=undefined;
              item.mesReprogramadoMayo=undefined;
              item.comentarioMayo=undefined;
            }
            if(nroMes==6){
              item.idEstadoJunio=undefined;
              item.mesReprogramadoJunio=undefined;
              item.comentarioJunio=undefined;
            }
            if(nroMes==7){
              item.idEstadoJulio=undefined;
              item.mesReprogramadoJulio=undefined;
              item.comentarioJulio=undefined;
            }
            if(nroMes==8){
              item.idEstadoAgosto=undefined;
              item.mesReprogramadoAgosto=undefined;
              item.comentarioAgosto=undefined;
            }
            if(nroMes==9){
              item.idEstadoSetiembre=undefined;
              item.mesReprogramadoSetiembre=undefined;
              item.comentarioSetiembre=undefined;
            }
            if(nroMes==10){
              item.idEstadoOctubre=undefined;
              item.mesReprogramadoOctubre=undefined;
              item.comentarioOctubre=undefined;
            }
            if(nroMes==11){
              item.idEstadoNoviembre=undefined;
              item.mesReprogramadoNoviembre=undefined;
              item.comentarioNoviembre=undefined;
            }
            if(nroMes==12){
              item.idEstadoDiciembre=undefined;
              item.mesReprogramadoDiciembre=undefined;
              item.comentarioDiciembre=undefined;
            }
          }
          else{
            if(nroMes==1){
              item.mesReprogramadoEnero=undefined;
              item.comentarioEnero=item.comentarios;
            }
            if(nroMes==2){
              item.mesReprogramadoFebrero=undefined;
              item.comentarioFebrero=item.comentarios;
            }
            if(nroMes==3){
              item.mesReprogramadoMarzo=undefined;
              item.comentarioMarzo=item.comentarios;
            }
            if(nroMes==4){
              item.mesReprogramadoAbril=undefined;
              item.comentarioAbril=item.comentarios;
            }
            if(nroMes==5){
              item.mesReprogramadoMayo=undefined;
              item.comentarioMayo=item.comentarios;
            }
            if(nroMes==6){
              item.mesReprogramadoJunio=undefined;
              item.comentarioJunio=item.comentarios;
            }
            if(nroMes==7){
              item.mesReprogramadoJulio=undefined;
              item.comentarioJulio=item.comentarios;
            }
            if(nroMes==8){
              item.mesReprogramadoAgosto=undefined;
              item.comentarioAgosto=item.comentarios;
            }
            if(nroMes==9){
              item.mesReprogramadoSetiembre=undefined;
              item.comentarioSetiembre=item.comentarios;
            }
            if(nroMes==10){
              item.mesReprogramadoOctubre=undefined;
              item.comentarioOctubre=item.comentarios;
            }
            if(nroMes==11){
              item.mesReprogramadoNoviembre=undefined;
              item.comentarioNoviembre=item.comentarios;
            }
            if(nroMes==12){
              item.mesReprogramadoDiciembre=undefined;
              item.comentarioDiciembre=item.comentarios;
            }
          }
        });
      }
        item.mesReprogramado=undefined;
        item.comentarios=undefined;  
    

    
  }

  openDialogAmpliacion(item: DetalleSeguimientoPasstModel): void {
    item.anio = this.model.anio;
    item.idSede = this.model.idSede;
    item.sede = this.listaSedes.find(x=>x.idSede == item.idSede)?.nombre;
    const dialogRef = this.dialog.open(PasstActividadSolicitarEdicionDialogComponent, {
      width: '900px',
      data: item,
    });
    dialogRef.afterClosed().subscribe((result: DetalleSeguimientoPasstModel) => {
      if(result){
        item.idEstadoModificacion = eEstadosEdicionPasstAcitividad.EdicionSolicitada;
        item.puedeSolicitar = false;
      }
    });
  }

  openDialogSolicitarEdicion(): void {
    let item:DetalleSeguimientoPasstModel = new DetalleSeguimientoPasstModel();
    item.anio = this.model.anio;
    item.idSede = this.model.idSede;
    item.sede = this.listaSedes.find(x=>x.idSede == item.idSede)?.nombre;
    const dialogRef = this.dialog.open(PasstSolicitarProgramacionEdicionDialogComponent, {
      width: '900px',
      data: item,
    });
    dialogRef.afterClosed().subscribe((result: DetalleSeguimientoPasstModel) => {
      if(result){
        item.idEstadoModificacion = eEstadosEdicionPasstAcitividad.EdicionSolicitada;
        item.puedeSolicitar = false;
      }
    });
  }

  eliminarActividad(item: DetalleSeguimientoPasstModel){

    const dialogRef = this.dialog.open(PasstActividadEliminarDialogComponent, {
        width: '700px',
        // data: { name: this.name, animal: this.animal}
        data: item
      });    
      dialogRef.afterClosed().subscribe((result: DetalleSeguimientoPasstModel) => {
        if(result){
          this.dataSourceTree.data.forEach(function (grupo1) {
            if(grupo1.children){
              grupo1.children.forEach(function (grupo2) {
                if(grupo2.children){
                  grupo2.children.forEach(function (actividad) {
                    if(actividad.data){
                      actividad.data = actividad.data.filter((obj) => obj.idPasstActividad != result.idPasstActividad);
                    }
                  });
                }
              });
            }
          }); 
          const data = this.dataSourceTree.data;
          this.dataSourceTree.data = [];
          this.dataSourceTree.data = data;
        }
      });
  }

  openDialogLogActividad(item: DetalleSeguimientoPasstModel): void {

    this.passtService.getComentariosActividad(item.idPasstActividad).subscribe((result: ILogModel[]) => {
      
    const dialogRef = this.dialog.open(LogDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: result.filter(x=>x.comentarios!=""),
    });

    dialogRef.afterClosed().subscribe((result) => {});
      
    },error => {
      //console.log('oops', error)
      this.alertDialogService.open(`Se produjo un error al registrar su información, por favor contactar con el administrador. Detalle: ${error.title}.`)
    });

  }

  openDialogLogPasst(): void {

    this.passtService.getComentarios(this.idPasst).subscribe((result: ILogModel[]) => {
      
    const dialogRef = this.dialog.open(LogDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: result.filter(x=>x.comentarios!=""),
    });

    dialogRef.afterClosed().subscribe((result) => {});
      
    },error => {
      //console.log('oops', error)
      this.alertDialogService.open(`Se produjo un error al registrar su información, por favor contactar con el administrador. Detalle: ${error.title}.`)
    });

  }
  
  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    // this.serviceSede
    //   .getListFiltered(this.filter)
    //   .subscribe((data) => {
    //     this.model = data;
    //     this.resultsLength = data.total;
    //   });
  }

  exportarPasst(){
    this.passtService
      .exportarById(this.idPasst)
      .subscribe(data => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob:any = data.body;// new Blob([data.body], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        
        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `passt-${Date.now()}.xlsx`);

      //  this.createImageFromBlob(data);
      //  this.isImageLoading = false;
     }, error => {
      this.alertDialogService.open(`Se produjo un error al registrar su información, por favor contactar con el administrador.`)
     });
    
  }
}